module.exports = __webpack_public_path__ + "0920a637675b4b324c328571b370db28.png";